import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import ClientsList from './components/ClientsList';
import ClientDetail from './components/ClientDetail';
import AddClient from './components/AddClient';
import UsersList from './components/UsersList';
import AddUser from './components/AddUser';
import MyProfile from './components/MyProfile';
import './App.css';

// Re-export API and axiosInstance for all components (legacy import path ../App)
export const API = `${(process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '')}/api`;
export const axiosInstance = axios.create({ baseURL: API });
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Restore user from localStorage if present
    const stored = localStorage.getItem('user');
    const token = localStorage.getItem('token');
    
    if (stored && token) {
      try { 
        setUser(JSON.parse(stored)); 
      } catch (e) {
        console.error('Failed to parse user from localStorage:', e);
      }
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
    window.location.href = '/login';
  };

  const RequireAuth = ({ element }) => {
    const token = localStorage.getItem('token');
    if (!token) return <Navigate to="/login" replace />;
    return element;
  };

  return (
    <BrowserRouter>
      <div className="theme-beastmode">
        <Routes>
          <Route path="/login" element={<Login setUser={setUser} />} />
          <Route 
            path="/*" 
            element={
              <RequireAuth 
                element={<Dashboard user={user} onLogout={handleLogout} />} 
              />
            } 
          />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
